module.exports = __webpack_public_path__ + "encs/web_store/avpv/img/upload.8850e653.svg";